export default "/images/smart_contract_development_and_audits__icon.png";